import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd, IoIosCopy, IoIosRefresh } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getSchoolYearsList } from '../../actions/schoolYears'
import CustomSelect from '../../components/CustomSelect'
import { useFormik } from 'formik'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { getCourses, getLessons, getTeachersList } from '../../actions/common'
import { getListEMK, deleteEMK, createCopyEMK } from '../../actions/educationalMethodologicalKits'


export default function EducationalMethodologicalKits() {
  const dispatch = useDispatch()

  const { list } = useSelector(state => state.educationalMethodologicalKits)
  const { list: yearList } = useSelector(state => state.school_years)
  const { teachers, lessons } = useSelector(state => state.common)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [select, setSelect] = useState(null);

  const [electiveCourse, setElectiveCourse] = useState(false);
  const [statusClose, setStatusClose] = useState(false);
  /// не совпадают содержание и найминг 
  const [data, setData] = useState();

  const {
    values,
    setFieldValue,
  } = useFormik({
    initialValues: {},
    enableReinitialize: true,
  })

  useEffect(() => {
    dispatch(getSchoolYearsList())
    // ДАННЫЕ ПОДТВЕРДИТЬ !!!  
    dispatch(getTeachersList());
    dispatch(getLessons());
    dispatch(getListEMK());

  }, [])

  const handleSelect = (data) => () => {
    if (select?.tkid === data.tkid) {
      setSelect(null)
    } else {
      setSelect(data)
    }
  }
  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteEMK(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { kitname, lesson, end_date, start_date, mid, lid, tkid } = data
    const currLesson = lessons?.find(el => el.lid === lid)?.name
    const currTeacher = teachers?.find(el => el.mid === mid)?.calc_fio /// не совпадают йд-ки массивов
    return (
      <tr
        onClick={handleSelect(data)}
        onDoubleClick={openModal(data)}
        style={{ backgroundColor: select?.tkid === data.tkid ? '#3689FF' : '' }}
      >
        <td>{kitname}</td>
        <td>{currTeacher}</td>
        <td>{currLesson}</td>
        <td>{start_date}</td>
        <td>{end_date}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: tkid, name: kitname })}><BiTrash /></i></td>
      </tr>
    )
  }

  const handleUpdateTable = () => {
    dispatch(getListEMK(values))
    closeModal()
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          classGroup={data}
          height={'430px'}
          electiveCourse={electiveCourse}
          addMode={!selectedItem.tkid}
          filters={values}
          lessons={lessons}
        />
      }
      <h1>Учебно-методические комплекты</h1>

      <div className={styles.line}>
        <CustomSelect
          title="Учебный год"
          valuesName="xp_key"
          value={values.xp_key}
          options={yearList && arrayForSelect(yearList, 'name', 'xp_key')}
          setFieldValue={setFieldValue}
          width={165}
        />
        <CustomSelect
          title="Дисциплина"
          valuesName="lid"
          value={values.lid}
          options={lessons && arrayForSelect(lessons, 'name', 'lid')}
          setFieldValue={setFieldValue}
          width={165}
        />
        <CustomSelect
          title='Преподаватель'
          valuesName="mid"
          options={teachers && arrayForSelect(teachers, 'calc_fio', 'mid')}
          width={165}
          setFieldValue={setFieldValue}
        />
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={handleUpdateTable}
        >
          <IoIosRefresh size={30} />

          Обновить
        </Button>

        {select?.tkid &&
          <div className={styles.copy}>
            <Button
              style={{ padding: '.5rem 1.5rem', margin: '12px' }}
              onClick={() => dispatch(createCopyEMK(select?.tkid))}
            >
              <IoIosCopy size={30} />
              Создать копию
            </Button>
          </div>}

      </div>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Название</th>
            <th>Преподаватель</th>
            <th>Дисциплина</th>
            <th>с</th>
            <th>по</th>
            <th>Удалить</th>
          </tr>
        </thead>
        <tbody>
          {list && list.map(renderLi)}
        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div >
  )
}
